/* eslint-disable */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Table } from "../../../ui/Table";
import { Tooltip } from "../../../ui/Tooltip";
import { useMutation } from "@tanstack/react-query";
import { ErrorMessage, SuccessMessage } from "../../../../utils/toastify";
import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";
import { useAuth } from "../../../../Context/AuthContext";
import _ModalDanger from "../../../modal/_ModalDanger";
const TableListPricesRCS = ({
  data = [],
  isLoading = false,
  refetchTable,
  uidCustomer,
  arrayRCSTypes = {},
}) => {
  const auth = useAuth();
  const { token } = auth.getSessionData();
  const [remove, setRemove] = useState({
    visible: false,
    data: null,
  });

  const columns = [
    {
      accessor: "limitMin",
      Header: "Rango Min",
    },
    {
      accessor: "limitMax",
      Header: "Rango Max",
    },
    {
      accessor: "unitPrice",
      Header: "Precio Unitario",
    },
    {
      accessor: "idrcstype",
      Header: "Tipo de RCS",
      Cell: (rowData) => {
        let value = rowData.row.original.idrcstype;
        return (
          //
          <span className="bg-blue-100 hover:bg-gray-200 hover:text-gray-400 text-blue-700 border-none rounded-lg flex items-center justify-center gap-2 px-2 py-1 w-[200px]">
            {arrayRCSTypes[value] || "---"}
          </span>
        );
      },
    },
    {
      accessor: "none",
      Header: "Acciones",
      disableSortBy: true,
      headerProps: {
        className: "text-center w-[100px]",
      },
      cellProps: {
        className: "text-center",
      },
      Cell: (rowData) => {
        let item = rowData.row.original;

        return (
          <div className="flex justify-end gap-2">
            <Tooltip message="Eliminar" placement="top">
              <button
                className="bg-gray-100 hover:bg-gray-200 hover:text-gray-400 text-gray-700 border-none rounded-lg flex items-center gap-2 px-2 py-1"
                onClick={() => setRemove({ visible: true, data: item })}
              >
                <span className="material-symbols-outlined">delete</span>
              </button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const { mutate: deleteTable, isPending } = useMutation({
    mutationFn: async (id) => {
      const res = await httpClient(
        "post",
        `${ApiEndpoint}configuration/removercspricesbycustomer`,
        {
          idcustomer: uidCustomer,
          partnerrcsprice: id,
        },
        token,
      );
      return res.data;
    },
    onSuccess: (data) => {

      if (data?.error) {
        ErrorMessage("Error al eliminar precio");
        return;
      }

      SuccessMessage("Se ha eliminado el precio del cliente");
      refetchTable();
      setRemove({ visible: false, data: null })
    },
    onError: (error) => {
      ErrorMessage("Error al eliminar precio");
    },
  });

  return (
    <div>
      <Table
        columns={columns}
        data={data}
        loading={isLoading}
        config={{
          search: false,
          pageSize: 10,
          perPage: 10,
          pagination: true,
          rowInfo: true,
          rowsPerPageSelection: true,
          navButtons: false,
          footer: true,
        }}
      />
      <_ModalDanger
        visible={remove.visible}
        onClose={() => setRemove({ visible: false, data: null })}
        title="Eliminar Precio"
        description="¿Desea eliminar el precio?"
        onAction={() => {
          deleteTable(remove?.data?.idpartnerrcsprice);
        }}
        isLoading={isPending}
      />
    </div>
  );
};

TableListPricesRCS.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
  refetchTable: PropTypes.func,
  uidCustomer: PropTypes.string,
  arrayRCSTypes: PropTypes.array,
};

export default TableListPricesRCS;
